import { render, staticRenderFns } from "./SignRequestTemplates.vue?vue&type=template&id=37964f6e&"
import script from "./SignRequestTemplates.vue?vue&type=script&lang=js&"
export * from "./SignRequestTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports